import { AutocompleteInput } from './AutocompleteInput';
import { Checkbox } from './Checkbox';
import { Form as FormComponent } from './Form';
import { ImageInput } from './ImageInput';
import { Input } from './Input';
import { SearchInput } from './SearchInput';
import { Select } from './Select';
import { Textarea } from './Textarea';
import { Toggle } from './Toggle';

export const Form = Object.assign(FormComponent, {
    Autocomplete: AutocompleteInput,
    Checkbox,
    ImageInput,
    Input,
    SearchInput,
    Select,
    Textarea,
    Toggle,
});
